export default __webpack_public_path__ + "static/media/collections-baner-2.49f809f8.svg";